import { AppPermission, AppRole, UserSession, PERMISSION_DEFINITIONS } from '../types';

// Todos os IDs de permissão disponíveis
export const ALL_PERMISSIONS: AppPermission[] = PERMISSION_DEFINITIONS.map(p => p.id);

// Define standard roles and their permissions for the application
export const ROLE_PERMISSIONS: Record<AppRole, AppPermission[]> = {
  admin: ALL_PERMISSIONS,
  manager: [
    'view_dashboard', 'view_dashboard_kpis', 'view_dashboard_charts',
    'view_orders', 'create_orders', 'manage_orders', 'approve_orders', 'print_os',
    'view_order_prices', 'edit_order_prices', 'view_order_repasse', 'edit_order_repasse', 'view_order_margin',
    'view_routes', 'manage_routes', 'create_routes', 'dispatch_routes', 'view_driver_tracking',
    'view_financial', 'manage_financial', 'create_financial', 'pay_financial', 'view_financial_values',
    'view_medicoes', 'manage_medicoes', 'create_medicoes', 'approve_medicoes', 'view_medicoes_valores', 'export_medicoes',
    'view_vehicles', 'manage_vehicles', 'create_vehicles', 'manage_checklists', 'manage_maintenance', 'manage_abastecimento', 'view_vehicle_crlv',
    'view_people', 'manage_people', 'create_people', 'view_people_docs', 'view_people_bank',
    'view_proposals', 'manage_proposals', 'approve_proposals',
    'view_fiscal', 'manage_fiscal', 'emit_cte', 'emit_nfse', 'cancel_fiscal',
    'export_reports'
  ],
  user: [
    'view_dashboard', 'view_dashboard_charts',
    'view_orders', 'create_orders', 'manage_orders', 'print_os',
    'view_order_prices',
    'view_routes', 'manage_routes', 'create_routes', 'view_driver_tracking',
    'view_medicoes', 'manage_medicoes', 'create_medicoes', 'view_medicoes_valores', 'export_medicoes',
    'view_vehicles', 'manage_checklists', 'manage_abastecimento', 'view_vehicle_crlv',
    'view_people', 'manage_people', 'create_people',
    'view_proposals', 'manage_proposals',
    'view_fiscal', 'emit_cte', 'emit_nfse',
    'export_reports'
  ],
  driver: [
    'view_orders',
    'view_routes',
    'manage_checklists',
    'manage_abastecimento'
  ],
  client: [
    'view_orders',
    'view_proposals',
    'manage_proposals'
  ],
  guest: []
};

/**
 * Service to handle permissions and roles logic.
 */
export const PermissionsService = {
  getPermissionsForRole(role: AppRole): AppPermission[] {
    return ROLE_PERMISSIONS[role] || [];
  },

  hasPermission(user: UserSession | null, permission: AppPermission): boolean {
    if (!user) return false;
    return user.permissions.includes(permission);
  },

  hasRole(user: UserSession | null, role: AppRole): boolean {
    if (!user) return false;
    return user.role === role;
  },

  hasAnyPermission(user: UserSession | null, permissions: AppPermission[]): boolean {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return permissions.some((p) => user.permissions.includes(p));
  },

  hasAllPermissions(user: UserSession | null, permissions: AppPermission[]): boolean {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return permissions.every((p) => user.permissions.includes(p));
  }
};

